<template>
    <record-form :id="id"
                 :form-fields="formFields"
                 :record-type="recordType">
    </record-form>
</template>

<script>
    export default {
        props: {
            formFields: { type: Object, required: true },
            recordType: { type: String, required: true },
            resourceUriPrefix: { type: String, required: true }
        },

        data() {
            return {
                id: this._uid
            }
        },

        created() {
            EventDispatcher.listen('recordFormSubmitted' + this.id, (form) => {
                this.onSubmit(form);
            });

            EventDispatcher.listen('recordFormCanceled' + this.id, () => {
                this.onCancel();
            });
        },

        methods: {
            onSubmit(form) {
                form.post(this.createRecordUri()).then(response => {
                    window.location = this.viewRecordsUri();
                }).catch(error => {
                    var firstFieldWithError = null;
                    for (var fieldNameWithError in error.errors) {
                        firstFieldWithError = fieldNameWithError;
                        break;
                    }
                    EventDispatcher.fire('setFocusOnField', firstFieldWithError);
                });
            },

            onCancel() {
                window.location = this.viewRecordsUri();
            },

            createRecordUri() {
                return this.resourceUriPrefix;
            },

            viewRecordsUri() {
                return this.resourceUriPrefix;
            }
        }
    }
</script>